import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/lenis";

const NAV = [
  { label: "About", href: "#about" },
  { label: "Workshops & Training", href: "#workshops" },
  { label: "Consulting Services", href: "#consulting" },
  { label: "Why Us", href: "#why-us" },
  { label: "Contact", href: "#contact" },
];

const SERVICES = [
  "Manager Development",
  "Workplace Skills Labs",
  "HR Consulting",
  "Operations Consulting",
];

const Footer = () => (
  <footer data-testid="footer" className="bg-ink text-white px-6 md:px-10 pt-4 pb-12">
    <div className="max-w-7xl mx-auto border-t border-white/10 pt-14">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
        <div className="md:col-span-5">
          <p className="font-display text-3xl md:text-4xl font-bold tracking-tight">
            Network <span className="font-serif italic font-medium text-terracotta-light">in Colors</span>
          </p>
          <p className="mt-5 text-sm md:text-base text-white/60 leading-relaxed max-w-sm">
            HR &amp; Operations consulting for growing businesses,
            developing capable managers, stronger teams, and better workplaces.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40 mb-5">Explore</p>
          <ul className="space-y-3">
            {NAV.map((l) => (
              <li key={l.href}>
                <button
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  onClick={() => scrollToId(l.href)}
                  className="text-sm text-white/75 hover:text-terracotta-light transition-colors"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40 mb-5">Services</p>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s}>
                <button
                  data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  onClick={() => scrollToId("#workshops")}
                  className="text-sm text-white/75 hover:text-terracotta-light transition-colors text-left"
                >
                  {s}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-xs text-white/40">
          © {new Date().getFullYear()} Network in Colors. All rights reserved.
        </p>
        <div className="flex items-center gap-6">
          <Link
            to="/terms"
            data-testid="footer-link-terms"
            className="text-xs text-white/40 hover:text-terracotta-light transition-colors"
          >
            Terms & Conditions
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-link-privacy"
            className="text-xs text-white/40 hover:text-terracotta-light transition-colors"
          >
            Privacy Policy
          </Link>
        </div>
        <p className="font-serif italic text-sm text-white/50">
          Where businesses and employees thrive together.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
